import { render } from "./HeroKeyLabel.vue?vue&type=template&id=6db4ead2&scoped=true"
import script from "./HeroKeyLabel.vue?vue&type=script&lang=js"
export * from "./HeroKeyLabel.vue?vue&type=script&lang=js"

import "./HeroKeyLabel.vue?vue&type=style&index=0&id=6db4ead2&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db4ead2"]])

export default __exports__